import { defineMessages } from 'react-intl';

export default defineMessages({
  close: { id: 'gofre.Ui.NotificationAlert.close' },
  text: { id: 'gofre.Ui.NotificationAlert.text' },
  zipDownloadReady: { id: 'gofre.Ui.NotificationAlert.text.zipDownloadReady' },
  commercialBeta: { id: 'gofre.Ui.NotificationAlert.text' }, // TODO: change to correct text
  bulkOcrScan: { id: 'gofre.user-notification.bulk-ocr-scan.body' },
  bulkOcrScanWithLink: {
    id: 'gofre.user-notification.bulk-ocr-scan.body-with-link',
  },
});
